import { dateDiff, dateIsSame } from 'javascripts/util/dateFns';

export const updateDates = ({
  scale,
  scrollLeft,
  updateDates,
  fromDate,
  toDate,
  setDates,
}) => {
  const startDate = scale.offsetToDate(scrollLeft);

  const diff = dateDiff(fromDate, toDate);
  const endDate = startDate.clone().add(diff, 'days');
  if (!dateIsSame(startDate, toDate) || !dateIsSame(toDate, endDate)) {
    updateDates(startDate, endDate);
    setDates({ fromDate: startDate, toDate: endDate });
  }
};
